import { render, staticRenderFns } from "./StationSlide.vue?vue&type=template&id=5e910671&scoped=true"
import script from "./StationSlide.vue?vue&type=script&lang=js"
export * from "./StationSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e910671",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e910671')) {
      api.createRecord('5e910671', component.options)
    } else {
      api.reload('5e910671', component.options)
    }
    module.hot.accept("./StationSlide.vue?vue&type=template&id=5e910671&scoped=true", function () {
      api.rerender('5e910671', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/StationSlide.vue"
export default component.exports